import { useEffect } from "react";
import * as Sentry from "@sentry/react";

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import { env } from "process";

if (env.IS_LOCAL !== "true") {
  Sentry.init({
    dsn: "https://e02c93dc241b53e918a9562f46a9f163@o4507936412270592.ingest.de.sentry.io/4507936415481936",
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      /^\//,

      // Any subdomain
      /^https:\/\/[^.]+\.lendtech\.co/,

      // Any subdomain of api.lendtech.co
      /^https:\/\/api\..+\.lendtech\.co/,

      // lendtech-staging.herokuapp.com
      /^https:\/\/lendtech-staging\.herokuapp\.com/,
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.25,
    replaysOnErrorSampleRate: 1.0,
  });
}
